var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavanderiaW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4348 40H13.5652C12.7012 40 12 39.2596 12 38.3448V9.65517C12 8.74041 12.7012 8 13.5652 8H34.4348C35.2988 8 36 8.74041 36 9.65517V38.3448C36 39.2596 35.2988 40 34.4348 40Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8697 26.2067C32.8697 31.3863 28.8983 35.5861 24.0002 35.5861C19.1021 35.5861 15.1306 31.3863 15.1306 26.2067C15.1306 21.0272 19.1021 16.8274 24.0002 16.8274C28.8983 16.8274 32.8697 21.0272 32.8697 26.2067Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8695 14.6208H15.1575V11.3105H23.4782V11.8622C23.4782 13.3861 22.3105 14.6208 20.8695 14.6208Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6516 12.9655C27.6516 13.27 27.4179 13.5172 27.1299 13.5172C26.8419 13.5172 26.6082 13.27 26.6082 12.9655C26.6082 12.6609 26.8419 12.4138 27.1299 12.4138C27.4179 12.4138 27.6516 12.6609 27.6516 12.9655Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9127 13.5171C33.9127 14.7353 32.9777 15.724 31.8257 15.724C30.6737 15.724 29.7388 14.7353 29.7388 13.5171C29.7388 12.2989 30.6737 11.3102 31.8257 11.3102C32.9777 11.3102 33.9127 12.2989 33.9127 13.5171Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 19.0344C21.58 19.0344 19.4607 20.3795 18.2607 22.3967C18.9181 23.5012 19.3042 24.8044 19.3042 26.2069C19.3042 27.6093 18.9181 28.9125 18.2607 30.0171C19.4607 32.0342 21.58 33.3793 23.9999 33.3793C27.746 33.3793 30.7825 30.1682 30.7825 26.2069C30.7825 22.2455 27.746 19.0344 23.9999 19.0344Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavanderiaW);
export default __webpack_public_path__ + "static/media/lavanderia-w.d0491f18057f69b0ba25e401391e124d.svg";
export { ForwardRef as ReactComponent };